import Model from './Model'
import CommentLike from './CommentLike'

export default class Comment extends Model {
  resource() {
    return 'comments'
  }

  likes() {
    return this.hasMany(CommentLike)
  }
}
